import React, { useState } from "react";
import NoticeCard from "./NoticeCard";
import { Button, notification, Popover, Spin } from "antd";
import StopConfirmationContent from "./StopConfirmationContent";
import BinApiService from "src/api/BinApiService";
import PremierPlusBinDTO from "src/models/PremierPlusBinDTO";

interface DryerOperationsCardProps{
    binDto: PremierPlusBinDTO | null;
    handleShowDryerSettingsModal: () => void;
    handleClickViewDrying: () => void;
}

const DryerOperationsCard = ({ binDto, handleShowDryerSettingsModal, handleClickViewDrying }: DryerOperationsCardProps) => {
    
    const [isSpinning, setIsSpinning] = useState(false);
    const [sequencedDryerStopPopoverOpen, setSequencedDryerStopOpen] = useState(false);
    const [stopDryerPopoverOpen, setStopDryerPopoverOpen] = useState(false);
    
    const onClickYesStopDryer = async () => {
      try{
        const result = await BinApiService.premierPlus_StopDryingOperation(binDto?.binId ?? 0, true);
        notification.success({ message: 'Dryer stopped successfully' });
      }catch(err){
        console.error('Error stopping dryer:', err);
        notification.error({ message: 'Error stopping dryer', description: 'Please try again later.' });
      }finally{
      }

      setStopDryerPopoverOpen(false);
    }

    const onClickNoStopDryer = () => {
      setStopDryerPopoverOpen(false);
    }

    const onClickYesSequencedDryerStop = async () => {
        try{
            setIsSpinning(true);
            const result = await BinApiService.premierPlus_StopDryingOperation(binDto?.binId ?? 0, false);
            notification.success({ message: 'Dryer stopped successfully' });
        }catch(err){
            console.error('Error stopping dryer:', err);
            notification.error({ message: 'Error stopping dryer', description: 'Please try again later.' });
        }finally{
            setIsSpinning(false);
        }

        setStopDryerPopoverOpen(false);
    }

    const onClickNoSequencedDryerStop = () => {
      setSequencedDryerStopOpen(false);
    }
    
    return(
        <NoticeCard 
        title="Dryer is running"
        description="Automated drying operations are currently active"
        buttons={
            <>
                <Popover
                open={sequencedDryerStopPopoverOpen}
                trigger="click"
                onOpenChange={(newOpen) => {
                    if (!newOpen) setSequencedDryerStopOpen(false);
                }}
                content={
                    <Spin spinning={isSpinning}>
                        <StopConfirmationContent
                        message="Are you sure you want to stop drying operations?"
                        onConfirm={onClickYesSequencedDryerStop}
                        onCancel={onClickNoSequencedDryerStop}
                        />
                    </Spin>
                }
                >
                    <Button type="primary" danger onClick={() => setSequencedDryerStopOpen(true)}>
                        Sequenced Dryer Stop
                    </Button>
                </Popover>

                <Popover
                open={stopDryerPopoverOpen}
                trigger="click"
                onOpenChange={(newOpen) => {
                    if (!newOpen) setStopDryerPopoverOpen(false);
                }}
                content={
                    <Spin spinning={isSpinning}>
                        <StopConfirmationContent
                        message="Are you sure you want to stop drying operations?"
                        onConfirm={onClickYesStopDryer}
                        onCancel={onClickNoStopDryer}
                        />
                    </Spin>
                }
                >
                    <Button type="primary" danger onClick={() => setStopDryerPopoverOpen(true)}>
                    Stop All
                    </Button>
                </Popover>

                <Button type="primary" onClick={handleShowDryerSettingsModal}>
                    Change Settings
                </Button>

                <Button type="primary" onClick={handleClickViewDrying}>
                    View HMI 
                </Button>
            </>
        }
        />
    )
}

export default DryerOperationsCard;